import { render } from "./AmountSelector.vue?vue&type=template&id=2a3afb34&scoped=true"
import script from "./AmountSelector.vue?vue&type=script&lang=js"
export * from "./AmountSelector.vue?vue&type=script&lang=js"

import "./AmountSelector.vue?vue&type=style&index=0&id=2a3afb34&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3afb34"]])

export default __exports__